module.exports = __webpack_public_path__ + "img/admin.486dab46.svg";